//// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Angular locale 🇦🇷
import { registerLocaleData } from '@angular/common';
import localeEsAR from '@angular/common/locales/es-AR';
registerLocaleData(localeEsAR);

// Telerik Intl
import '@progress/kendo-angular-intl/locales/es/all';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
